import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { towns } from "@/data/services";

export const businessHours = [
  { day: "Sunday", time: "Closed", open: null },
  { day: "Monday", time: "8:00 AM - 6:00 PM", open: [8, 18] },
  { day: "Tuesday", time: "8:00 AM - 6:00 PM", open: [8, 18] },
  { day: "Wednesday", time: "8:00 AM - 6:00 PM", open: [8, 18] },
  { day: "Thursday", time: "8:00 AM - 6:00 PM", open: [8, 18] },
  { day: "Friday", time: "8:00 AM - 5:00 PM", open: [8, 17] },
  { day: "Saturday", time: "8:00 AM - 11:00 AM", open: [8, 11] },
];

export function isOpenNow() {
  const now = new Date();
  const today = businessHours[now.getDay()];
  if (!today.open) return false;
  const h = now.getHours() + now.getMinutes() / 60;
  return h >= today.open[0] && h < today.open[1];
}

export function OpenBadge() {
  const open = isOpenNow();
  return (
    <span
      data-testid="hours-open-badge"
      className={`rounded-full px-3 py-1 text-xs font-bold ${
        open ? "bg-[#F4BE36] text-[#043B1C]" : "bg-white/15 text-white/70"
      }`}
    >
      {open ? "Open Now" : "Closed Now"}
    </span>
  );
}

export default function Footer() {
  return (
    <footer className="bg-[#043B1C] text-white" data-testid="site-footer">
      <div className="mx-auto grid max-w-[1160px] gap-12 px-5 py-16 md:grid-cols-2 lg:grid-cols-4 md:px-8">
        <div>
          <img src="/logo-footer.png" alt="Legacy Scapes Ltd." className="h-20 w-auto" />
          <p className="mt-4 max-w-xs text-sm leading-[1.6] text-white/90">
            Established lawn care and landscaping for residential and commercial properties across the St. Clair Corridor.
          </p>
          <p className="mt-4 flex items-start gap-2 text-sm leading-[1.8] text-white/85">
            <MapPin size={15} className="mt-1 shrink-0 text-[#F4BE36]" />
            <span>{towns.join(", ")}, and the communities between them.</span>
          </p>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#F4BE36]">Contact</p>
          <a
            href="tel:+15193841824"
            data-testid="footer-phone-link"
            className="mt-4 flex items-center gap-2 text-sm font-bold text-white transition-colors hover:text-[#F4BE36]"
          >
            <Phone size={14} strokeWidth={2.5} /> (519) 384-1824
          </a>
          <a
            href="mailto:sales@legacyscapes.ca"
            data-testid="footer-email-link"
            className="mt-3 flex items-center gap-2 break-all text-sm font-bold text-white transition-colors hover:text-[#F4BE36]"
          >
            <Mail size={14} strokeWidth={2.5} /> sales@legacyscapes.ca
          </a>
          <Link
            to="/admin"
            data-testid="footer-link-client-login"
            className="mt-5 inline-block rounded-full border border-white/30 px-6 py-2.5 text-xs font-bold text-white transition-colors hover:border-[#F4BE36] hover:text-[#F4BE36]"
          >
            Client Login
          </Link>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#F4BE36]">Quick Links</p>
          <div className="mt-4 flex flex-col gap-3">
            <Link to="/#services" data-testid="footer-link-services" className="text-sm font-bold text-white transition-colors hover:text-[#F4BE36]">Services</Link>
            <Link to="/residential" data-testid="footer-link-residential" className="text-sm font-bold text-white transition-colors hover:text-[#F4BE36]">Residential</Link>
            <Link to="/commercial" data-testid="footer-link-commercial" className="text-sm font-bold text-white transition-colors hover:text-[#F4BE36]">Commercial &amp; Property Management</Link>
            <Link to="/about" data-testid="footer-link-about" className="text-sm font-bold text-white transition-colors hover:text-[#F4BE36]">About</Link>
            <Link to="/contact" data-testid="footer-link-estimate" className="text-sm font-bold text-white transition-colors hover:text-[#F4BE36]">Request an Estimate</Link>
          </div>
        </div>
        <div>
          <div className="flex items-center gap-3">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#F4BE36]">Business Hours</p>
            <OpenBadge />
          </div>
          <div className="mt-4 divide-y divide-white/10" data-testid="footer-hours-list">
            {businessHours.map((h) => (
              <div key={h.day} className="flex items-center justify-between py-2 text-xs">
                <span className="font-bold text-white/80">{h.day}</span>
                <span className="text-white">{h.time}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-[1160px] flex-col gap-2 px-5 py-6 text-xs text-white/40 md:flex-row md:items-center md:justify-between md:px-8">
          <span data-testid="footer-copyright">© {new Date().getFullYear()} Legacy Scapes Ltd. All rights reserved.</span>
          <span>St. Clair Corridor, Ontario</span>
        </div>
      </div>
    </footer>
  );
}
